import type { OrderSummary } from '../../../../infrastructure/OMSClient';

// Mirrors the Shipping Address column: prefer shippingAddress, fall back to consignee.
export function formatShippingAddress(order: OrderSummary): string {
  const address = order.shippingAddress;
  const consignee = order.consignee;
  const pick = (...values: Array<string | undefined>) => values.find((value) => value?.trim())?.trim();
  return [
    pick(address?.address1, consignee?.address),
    pick(address?.address2),
    pick(address?.city, consignee?.city),
    pick(address?.state, consignee?.state),
    pick(address?.postcode, consignee?.zipcode),
    pick(address?.country, consignee?.countryCode),
  ]
    .filter(Boolean)
    .join(', ');
}

// Fields the backend (MergeFulfilmentOrdersHandler) compares to allow a merge. The preview
// must use the exact same set so "match" here implies the backend will accept the merge.
const ADDRESS_MATCH_FIELDS = ['firstName', 'lastName', 'address1', 'address2', 'city', 'state', 'postcode', 'country'] as const;

function addressMatchKey(order: OrderSummary): string {
  const address = order.shippingAddress;
  return ADDRESS_MATCH_FIELDS.map((field) => (address?.[field] ?? '').trim().toLowerCase()).join('|');
}

// True when every order shares the same shipping address by the backend's match fields.
export function shippingAddressesMatch(orders: OrderSummary[]): boolean {
  const [first, ...rest] = orders;
  if (!first || rest.length === 0) {
    return true;
  }
  const firstKey = addressMatchKey(first);
  return rest.every((order) => addressMatchKey(order) === firstKey);
}
